module.exports = __webpack_public_path__ + "static/media/laptop-side.cb2b05ee.png";